import api from './api';

class HeartbeatService {
  constructor() {
    this.interval = null;
    this.isActive = false;
    this.listenersAttached = false; // ⭐ NOVO: garante que os listeners só sejam registrados uma vez
  }

  start() {
    if (this.isActive) return;

    this.isActive = true;
    console.log('💓 Iniciando heartbeat...');

    this.sendHeartbeat();

    this.interval = setInterval(() => {
      this.sendHeartbeat();
    }, 30 * 1000);

    this.attachGlobalListenersOnce();
  }

  // ⭐ CORRIGIDO: antes isso ficava dentro de start() e era re-registrado
  // toda vez que a aba voltava a ficar visível, acumulando dezenas de
  // listeners duplicados ao longo de uma sessão longa
  attachGlobalListenersOnce() {
    if (this.listenersAttached) return;
    this.listenersAttached = true;

    // ⭐ CORRIGIDO: "beforeunload" dispara em QUALQUER recarregamento de página
    // (F5 incluso), não só ao fechar a aba de vez — estava marcando o usuário
    // como offline e zerando o contador de "conectado há..." a cada F5. Agora
    // só o limpador de 5 min (no backend) detecta desconexão de verdade.
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });
  }

  async sendHeartbeat() {
    try {
      await api.post('/api/auth/heartbeat');
    } catch (err) {
      console.warn('⚠️ Falha no heartbeat:', err.message);
    }
  }

    async sendLogout() {
    // ⭐ NOVO: trava extra — mesmo que esse serviço seja acionado várias vezes
    // (múltiplas abas, eventos duplicados do navegador), só a primeira chamada
    // de verdade dispara a requisição; as outras são ignoradas silenciosamente
    if (this.loggingOut) return;
    this.loggingOut = true;
    try {
      await api.post('/api/auth/logout');
    } catch (err) {
      // 401 aqui é esperado se o logout já aconteceu antes (sessão já encerrada)
      if (err.response?.status !== 401) {
        console.warn('⚠️ Falha no logout automático:', err.message);
      }
    }
  }

  stop() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
    this.isActive = false;
    console.log('💓 Heartbeat parado');
  }
}

const heartbeatServiceInstance = new HeartbeatService();
export default heartbeatServiceInstance;
